import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
// import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { MobileContext } from '../../providers/MobileProvider';
import CollapseButton from './CollapseButton';
import Header from './Header';
import Navbar from './Navbar';
import Footer from './Footer';
import { useLogout } from '../../services/useLogin';

const propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      icon: PropTypes.element,
      showInNav: PropTypes.bool,
      component: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.func,
      ]).isRequired,
      routes: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          path: PropTypes.string.isRequired,
          component: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.func,
          ]).isRequired,
        }),
      ),
    }),
  ).isRequired,
};

const navbarWidth = 256;

const useStyles = makeStyles(theme => ({
  drawerPaper: {
    padding: theme.spacing(3, 0),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    width: navbarWidth,
  },
  drawerOpen: {
    width: navbarWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(7),
    },
  },
}));

function Sidebar({ routes }) {
  const [isCollapse, setCollapse] = useState(true);
  const { isOpen, changeOpen } = useContext(MobileContext);
  const [doLogout] = useLogout();
  const classes = useStyles();

  const drawerProps = {
    classes: {
      root: clsx(classes.drawerPaper, {
        [classes.drawerOpen]: isCollapse,
        [classes.drawerClose]: !isCollapse,
      }),
      paper: clsx(classes.drawerPaper, {
        [classes.drawerOpen]: isCollapse,
        [classes.drawerClose]: !isCollapse,
      }),
    },
    open: isCollapse,
    variant: 'permanent',
  };

  const isValidViewport = (mq) => {
    if (mq.matches) {
      setCollapse(false);
    } else {
      setCollapse(true);
    }
  };

  useEffect(() => {
    const isDesktop = window.matchMedia('(min-width: 600px) and (max-width: 959px)');

    window.addEventListener('resize', () => isValidViewport(isDesktop));
    isValidViewport(isDesktop);
  }, []);

  function toggleOpen() {
    setCollapse(!isCollapse);
  }

  const handleDrawerToggle = () => {
    changeOpen();
  };

  return (
    <nav className={classes.drawer}>
      <Hidden smUp implementation="css">
        <Drawer
          variant="temporary"
          open={isOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <Header isOpen={isCollapse} />
          <CollapseButton isOpen={isOpen} onClick={handleDrawerToggle} />
          <Navbar routes={routes} />
          <Footer onClick={doLogout} />
        </Drawer>
      </Hidden>
      <Hidden xsDown implementation="css">
        <Drawer {...drawerProps}>
          <Header isOpen={isCollapse} />
          <CollapseButton isOpen={isCollapse} onClick={toggleOpen} />
          <Navbar routes={routes} />
          <Footer onClick={doLogout} />
        </Drawer>
      </Hidden>
    </nav>
  );
}

Sidebar.propTypes = propTypes;

export default Sidebar;
